import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const brandStyles = {
  primaryGreen: '#578d10ff',
  deepBlue: '#394C92',
  linkHover: '#68A637',
  lightBg: '#F0F5EB',
};

const getLogoStyle = (isMobileView) => ({
  height: '90px',
  objectFit: 'contain',
  '@media (max-width: 768px)': {
    height: '60px',
  },
});

export default function Navbar() {
  const location = useLocation();
  const [activePath, setActivePath] = useState("/");

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    setActivePath(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 992;

  const navLinks = [
    { name: "Home", path: "/" },
    { name: "About Orgavitaz", path: "/About" },
    { name: "Portfolio", path: "/Portfolio" },
    { name: "Services", path: "/Services" },
    { name: "Sustainability", path: "/Sustainability" },
    { name: "Contact", path: "/contact" },
  ];

  const fontStyle = { fontFamily: "Optima, sans-serif" };

  return (
    <nav className="navbar navbar-expand-lg shadow-sm py-2" style={{ backgroundColor: "#fff", ...fontStyle }}>
      <div className="container-fluid px-5">
        {/* Logo */}
        <Link className="navbar-brand" to="/" style={fontStyle}>
          <img
            src="/images/Navbar/Orgavitaz_logo-1.png"
            alt="Orgavitaz Logo"
            style={{ height: isMobile ? '70px' :'90px', objectFit: "contain" }}
          />
        </Link>

        {/* Hamburger */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{ borderColor: brandStyles.linkHover }}
        >
          <span
            className="navbar-toggler-icon"
            style={{ filter: "invert(40%) sepia(60%) saturate(500%) hue-rotate(80deg)" }}
          ></span>
        </button>

        {/* Nav Links */}
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center gap-lg-3">
            {navLinks.map((link, idx) => (
              <li className="nav-item" key={idx}>
                <Link
                  className="nav-link "
                  to={link.path}
                  onClick={() => setActivePath(link.path)}
                  style={{
                    ...fontStyle,
                    color: activePath === link.path ? brandStyles.deepBlue : brandStyles.primaryGreen,
                    transition: "color 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (activePath !== link.path) e.target.style.color = brandStyles.linkHover;
                  }}
                  onMouseLeave={(e) => {
                    if (activePath !== link.path) e.target.style.color = brandStyles.primaryGreen;
                  }}
                >
                  {link.name}
                </Link>
              </li>
            ))}
          </ul>

          <div className="d-flex gap-3 mt-3 mt-lg-0 ms-lg-3">
            <Link
              to="/AdminLogin"
              className="btn btn-sm px-3"
              style={{
                ...fontStyle,
                color: brandStyles.deepBlue,
                borderColor: brandStyles.deepBlue,
                backgroundColor: "transparent",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = brandStyles.deepBlue;
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
                e.target.style.color = brandStyles.deepBlue;
              }}
            >
              Admin
            </Link>

            <Link
              to="/login"
              className="btn btn-sm px-3"
              style={{
                ...fontStyle,
                backgroundColor: brandStyles.primaryGreen,
                color: "#fff",
                borderColor: brandStyles.primaryGreen,
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = brandStyles.linkHover;
                e.target.style.borderColor = brandStyles.linkHover;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = brandStyles.primaryGreen;
                e.target.style.borderColor = brandStyles.primaryGreen;
              }}
            >
              Login
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}